import { render, staticRenderFns } from "./AuthorCard.vue?vue&type=template&id=a6140da2&scoped=true&"
import script from "./AuthorCard.vue?vue&type=script&lang=js&"
export * from "./AuthorCard.vue?vue&type=script&lang=js&"
import style0 from "./AuthorCard.vue?vue&type=style&index=0&id=a6140da2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6140da2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default,ArrowLeft: require('/vercel/path0/components/icons/ArrowLeft.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default})
